import { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store";
import {
  getCommentsThunk,
  getPostByIdThunk,
  deletePostThunk,
} from "../../store/actions/social.action";
import { PostCard } from "../../components/Social/PostCard";
import { CommentSection } from "../Social/CommentSection";
import { MainContent } from "../Social/styled";
import { message } from "antd";

const PostDetail = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [post, setPost] = useState<any>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    const fetchPost = async () => {
      try {
        const result = await dispatch(
          getPostByIdThunk({
            postId: id || "",
          })
        ).unwrap();

        if (result) {
          setPost(result);
          await dispatch(
            getCommentsThunk({
              postId: result._id,
              page: 1,
              limit: 10,
            })
          );
        }
      } catch (error) {
        console.error("Error fetching post:", error);
      }
    };

    fetchPost();
  }, [id, dispatch]);

  const handleDelete = async (postId: string) => {
    try {
      await dispatch(deletePostThunk({ postId }));
      message.success("Post deleted successfully");
      navigate("/");
    } catch (error) {
      message.error("Failed to delete post");
    }
  };

  if (!post) {
    return null;
  }

  return (
    <MainContent>
      <PostCard post={post} hideCommentModal onDelete={handleDelete} />
      <CommentSection post={post} />
    </MainContent>
  );
};

export default PostDetail;
